import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import InputGroup from "./../../elements/InputGroup";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const CreateColumnFieldModal = ({
  setCreateColumnFieldModal,
  setColumnTitle,
  addBookClosureColumns
}) => {

  return (
    <Modal
      title="Create Field"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setCreateColumnFieldModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCreateColumnFieldModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Create"
            onClick={addBookClosureColumns}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <InputGroup
                    label="Field name"
                    req={true}
                    inputs={[
                      <>
                        <input
                          type="text"
                          onChange={(e) => {setColumnTitle(e.target.value)}}

                        />
                      </>,
                    ]}
                  />
      </div>
    </Modal>
  );
};

export default CreateColumnFieldModal;
